import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagramLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.55 26",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .9,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1744 26H7.37482C3.31866 26 0 22.75 0 18.7777V7.22224C0 3.25 3.31866 0 7.37482 0H19.1744C23.2306 0 26.5493 3.25 26.5493 7.22224V18.7777C26.5493 22.75 23.2306 26 19.1744 26Z",
				fill: "#545BC6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 7.22224V18.7777C0 22.75 3.31866 26 7.37482 26H19.1744C23.2306 26 26.5493 22.75 26.5493 18.7777V7.22224C26.5493 6.49999 26.4755 5.84999 26.2542 5.19999C22.1244 1.95 16.8145 0 11.0622 0C8.3335 0 5.67857 0.433333 3.17119 1.3C1.25371 2.6 0 4.76666 0 7.22224Z",
				fill: "#5753BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0622 1.44434C7.37482 1.44434 3.98239 2.311 0.884975 3.75547C0.294994 4.8388 0 5.99431 0 7.22213V18.7776C0 22.7499 3.31866 25.9999 7.37482 25.9999H19.1744C23.2306 25.9999 26.5493 22.7499 26.5493 18.7776V7.36655C22.4931 3.68322 17.0358 1.44434 11.0622 1.44434Z",
				fill: "#6741B3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5493 9.38867C22.6406 5.41642 17.1832 2.88867 11.0622 2.88867C7.0798 2.88867 3.31866 3.972 0.147494 5.84976C0.0737504 6.28309 0 6.71642 0 7.222V18.7775C0 22.7497 3.31866 25.9997 7.37482 25.9997H19.1744C23.2306 25.9997 26.5493 22.7497 26.5493 18.7775V9.38867Z",
				fill: "#7942A2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5493 11.5557C22.9356 7.15016 17.3308 4.3335 11.0622 4.3335C6.93233 4.3335 3.17119 5.56125 0 7.65574V18.7779C0 22.7501 3.31866 26.0001 7.37482 26.0001H19.1744C23.2306 26.0001 26.5493 22.7501 26.5493 18.7779V11.5557Z",
				fill: "#86409C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5493 18.7778V14.0112C23.2306 9.10007 17.552 5.77783 11.0622 5.77783C6.93233 5.77783 3.09741 7.15008 0 9.38898V18.7778C0 22.7501 3.31866 26 7.37482 26H19.1744C23.2306 26 26.5493 22.7501 26.5493 18.7778Z",
				fill: "#98408F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5493 18.7777V17.0443C23.8943 11.2666 17.9945 7.22217 11.0622 7.22217C6.85856 7.22217 2.94994 8.73883 0 11.2666V18.7777C0 22.7499 3.31866 25.9999 7.37482 25.9999H19.1744C23.2306 25.9999 26.5493 22.7499 26.5493 18.7777Z",
				fill: "#AC4580"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.2542 20.8003C24.8531 13.867 18.5845 8.66699 11.0622 8.66699C6.71109 8.66699 2.8024 10.4003 0 13.217V18.7781C0 22.7503 3.31866 26.0003 7.37482 26.0003H19.1744C22.4931 26.0003 25.3693 23.8336 26.2542 20.8003Z",
				fill: "#BF3F92"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.0006 23.1113C24.6318 15.8891 18.5845 10.1113 11.0622 10.1113C6.56355 10.1113 2.58118 12.2058 0 15.4558V18.778C0 22.7502 3.31866 26.0002 7.37482 26.0002H19.1744C21.5344 26.0002 23.6731 24.8447 25.0006 23.1113Z",
				fill: "#C6417E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0622 11.5557C6.2686 11.5557 2.13869 14.1557 0 18.0557V18.7778C0 22.7501 3.31866 26.0001 7.37482 26.0001H19.1745C20.7969 26.0001 22.3456 25.4945 23.5256 24.5557C23.5256 24.339 23.5993 24.0501 23.5993 23.8334C23.5993 17.0445 17.9945 11.5557 11.0622 11.5557Z",
				fill: "#CD4569"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0626 13C5.90021 13 1.62285 16.3944 0.369141 21.0889C1.32786 23.9777 4.13026 26 7.37522 26H19.1748C20.2074 26 21.0923 25.7833 21.9773 25.4222C22.051 24.9167 22.1248 24.3389 22.1248 23.8333C22.1248 17.8389 17.1837 13 11.0626 13Z",
				fill: "#D34D5D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0623 14.4443C5.97371 14.4443 1.84382 18.2722 1.54883 23.111C2.87629 24.8443 5.01496 25.9999 7.37494 25.9999H19.1746C19.6171 25.9999 19.9858 25.9277 20.4283 25.8555C20.5758 25.2055 20.6496 24.5555 20.6496 23.8332C20.6496 18.6332 16.3722 14.4443 11.0623 14.4443Z",
				fill: "#DC5E50"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.8788 25.9997C19.1 25.2775 19.1737 24.5553 19.1737 23.8331C19.1737 19.4275 15.5601 15.8887 11.0615 15.8887C6.56282 15.8887 2.94922 19.4275 2.94922 23.8331C2.94922 24.0498 2.94922 24.3387 3.02292 24.5553C4.27668 25.422 5.75162 25.9997 7.3741 25.9997H18.8788Z",
				fill: "#E88152"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0631 17.3335C7.37572 17.3335 4.42578 20.2224 4.42578 23.8335C4.42578 24.4112 4.49955 24.9891 4.64703 25.4946C5.45823 25.8557 6.41698 26.0002 7.37572 26.0002H17.3317C17.5529 25.3502 17.7004 24.6279 17.7004 23.8335C17.7004 20.2224 14.7505 17.3335 11.0631 17.3335Z",
				fill: "#EBA352"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0618 18.8501C8.18562 18.8501 5.89941 21.089 5.89941 23.9057C5.89941 24.6278 6.04696 25.2778 6.3419 25.9278C6.71069 26.0001 7.00563 26.0001 7.37442 26.0001H15.7817C16.0766 25.3501 16.2242 24.6278 16.2242 23.9057C16.2242 21.089 13.938 18.8501 11.0618 18.8501Z",
				fill: "#F4C56E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0624 20.2944C8.99741 20.2944 7.375 21.8833 7.375 23.9056C7.375 24.7 7.66994 25.4223 8.11243 26H14.0123C14.4548 25.4223 14.7497 24.7 14.7497 23.9056C14.7497 21.8833 13.1273 20.2944 11.0624 20.2944Z",
				fill: "#F8DB89"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.6988 23.1108H8.84903C5.60414 23.1108 2.94922 20.5108 2.94922 17.3331V8.66642C2.94922 5.48867 5.60414 2.88867 8.84903 2.88867H17.6988C20.9437 2.88867 23.5986 5.48867 23.5986 8.66642V17.3331C23.5986 20.5108 20.9437 23.1108 17.6988 23.1108ZM8.84903 4.33309C6.41535 4.33309 4.42415 6.28309 4.42415 8.66642V17.3331C4.42415 19.7164 6.41535 21.6664 8.84903 21.6664H17.6988C20.1325 21.6664 22.1237 19.7164 22.1237 17.3331V8.66642C22.1237 6.28309 20.1325 4.33309 17.6988 4.33309H8.84903Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2757 18.0556C10.3995 18.0556 8.11328 15.8167 8.11328 13C8.11328 10.1833 10.3995 7.94442 13.2757 7.94442C16.1518 7.94442 18.438 10.1833 18.438 13C18.438 15.8167 16.1518 18.0556 13.2757 18.0556ZM13.2757 9.38891C11.2107 9.38891 9.58829 10.9778 9.58829 13C9.58829 15.0222 11.2107 16.6111 13.2757 16.6111C15.3406 16.6111 16.963 15.0222 16.963 13C16.963 10.9778 15.3406 9.38891 13.2757 9.38891ZM19.1755 7.22224C19.1755 7.65558 18.8805 7.94442 18.438 7.94442C17.9956 7.94442 17.7005 7.65558 17.7005 7.22224C17.7005 6.78891 17.9956 6.5 18.438 6.5C18.8805 6.5 19.1755 6.78891 19.1755 7.22224Z",
				fill: "white"
			})
		]
	})
});
export default SvgInstagramLogo;
